import React from 'react';

import {
  Modal
} from '@salesforce/design-system-react';

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);
  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, []);
  return [value, toggle];
}

const ProductOverlayInstructions = (props) => {
  const [isOpen, toggleIsOpen] = useToggle();

  return (
    <React.Fragment>
      <div 
          style={{ fontSize: '.8rem'}}>
            <span style={{ color: '#1B96FF', fontWeight: '600', cursor: 'pointer'}} onClick={toggleIsOpen}>Product Overlays Description</span>
        </div>
        <Modal
          isOpen={isOpen}
          onRequestClose={toggleIsOpen}
          heading="Product Overlays Description"
        >
          <div className="slds-p-around_medium">
          <div
            style={{ marginTop: '5px', marginBottom: '5px' }}
            className="slds-text-body_large"
          >
            Last step, you're almost done! Now's your chance to finalize your
            Journey Map. The tool below presents your entire story back to you
            and allows you to overlay what salesforce product / solutions are
            powering each touchpoint. You can include as many or as few
            products / solutions on each story element as you'd like, but
            don't go overboard.
          </div>
          <div
            style={{ marginTop: '5px', marginBottom: '5px' }}
            className="slds-text-body_large"
          >
            Drag and drop any of the icons onto a story element to associate
            that product / solution to that touchpoint. If you need to update
            any of the milestones or connecting events, you can do that as
            well.
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ProductOverlayInstructions;
